import { render, staticRenderFns } from "./coursePackage.vue?vue&type=template&id=4920b910&scoped=true"
import script from "./coursePackage.vue?vue&type=script&lang=js"
export * from "./coursePackage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4920b910",
  null
  
)

export default component.exports